/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Calibration
 * 
 * 1 = PressureTest
 * 
 * 2 = Quotation
 */
export enum CertificateType {
  Calibration = 0,
  PressureTest = 1,
  Quotation = 2
}
